var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Modal } from '@doordash/component-modal';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addTeamAccountBudget, fetchTeamAccountBudgets } from '../budgets_slice';
import { getTeamAccountBudgetsConfigurationOptions } from '../../../selectors/budgets_selector';
import { fetchTeamAccountGroups } from '../../Groups/groups_slice';
import { getTeamAccountGroups } from '../../Groups/groups_selector';
import formatTime, { getEndOfDay, getStartOfDay, } from '../../../utils/format_time';
import BudgetForm from './budget_form';
import track from '../../../utils/track';
import { BUDGET_REFRESH_INTERVAL, getArrayFromExpenseCodeValues, } from './budget_helper';
import { OnboardingStep } from '../../../types/GloblalTypes';
import { useSetOnboardingStepMutation } from '../../SelfServe/Onboarding/useSetOnboardingStepMutation';
export var CreateBudgetModal = function (_a) {
    var teamAccountId = _a.teamAccountId, onClose = _a.onClose, budget = _a.budget, maxBudgetAmountLimit = _a.maxBudgetAmountLimit;
    var dispatch = useDispatch();
    var _b = __read(React.useState({}), 2), formResponse = _b[0], setFormResponse = _b[1];
    var isEditing = Boolean(budget === null || budget === void 0 ? void 0 : budget.id);
    var groupsList = useSelector(getTeamAccountGroups);
    var fetchGroups = React.useCallback(function () {
        dispatch(fetchTeamAccountGroups(teamAccountId));
    }, [teamAccountId, dispatch]);
    React.useEffect(function () {
        fetchGroups();
    }, [teamAccountId, fetchGroups]);
    var teamAccountBudgetsConfigurationOptions = useSelector(getTeamAccountBudgetsConfigurationOptions);
    var setOnboardingStep = useSetOnboardingStepMutation(teamAccountId, OnboardingStep.ONBOARDING_STEP_ADD_BUDGET).setOnboardingStep;
    var handleFormSubmit = function (values, actions) {
        var budgetOptions = {
            name: values.budgetName,
            teamAccountId: teamAccountId,
            // choosing an address will be supported in a future iteration
            // but we still populate the address ID if one already existed
            addressId: (budget === null || budget === void 0 ? void 0 : budget.addressId) || 0,
            daysList: values.budgetDaysList.map(function (x) { return parseInt(x, 10); }),
            startTime: {
                hours: parseInt(formatTime(values.budgetStartTime, 'HH:mm', 'H'), 10),
                minutes: parseInt(formatTime(values.budgetStartTime, 'HH:mm', 'm'), 10),
            },
            endTime: {
                hours: parseInt(formatTime(values.budgetEndTime, 'HH:mm', 'H'), 10),
                minutes: parseInt(formatTime(values.budgetEndTime, 'HH:mm', 'm'), 10),
            },
            unitAmount: parseFloat(values.budgetUnitAmount) * 100,
            refreshInterval: values.budgetRefreshInterval,
            activeAtTimestamp: {
                seconds: parseInt(getStartOfDay(values.budgetActiveDate, 'MM/DD/YYYY', 'X'), 10),
            },
            inactiveAtTimestamp: {
                seconds: parseInt(getEndOfDay(values.budgetInactiveDate, 'MM/DD/YYYY', 'X'), 10),
            },
            groupIds: (values.budgetGroups && values.budgetGroups.map(function (group) { return group.id; })) ||
                [],
            expenseCodeConfig: {
                expenseCodeEnforcementMode: values.expenseCodeEnforcementMode,
                expenseCodeValidValuesList: getArrayFromExpenseCodeValues(values.expenseCodeValidValues),
            },
            budgetConfig: {
                permittedOrderContentsList: values.permittedOrderContentsList,
            },
        };
        if (isEditing) {
            budgetOptions.budgetId = budget === null || budget === void 0 ? void 0 : budget.id;
        }
        dispatch(addTeamAccountBudget(budgetOptions))
            .unwrap()
            .then(function (data) {
            var _a;
            dispatch(fetchTeamAccountBudgets({ teamAccountId: teamAccountId, includeGroupsInfo: true }));
            if (!isEditing) {
                // new budget
                var budgetType = budgetOptions.refreshInterval === 1 ? 'one-time' : 'recurring';
                var budgetFrequency = budgetType === 'recurring'
                    ? BUDGET_REFRESH_INTERVAL[budgetOptions.refreshInterval]
                    : null;
                var budgetId = (_a = data === null || data === void 0 ? void 0 : data.id) !== null && _a !== void 0 ? _a : '';
                track('workportal_submit_add_budget', {
                    budget_name: budgetOptions.name,
                    budget_amount: budgetOptions.unitAmount,
                    budget_type: budgetType,
                    budget_frequency: budgetFrequency,
                    budget_id: budgetId,
                    team_account_id: teamAccountId,
                });
                setOnboardingStep();
            }
            else {
                // edit budget
                track('workportal_edit_budget', {
                    budget_name: budgetOptions.name,
                    budget_id: budgetOptions.budgetId,
                });
            }
            onClose();
        }, function (errorResponse) {
            setFormResponse({
                response: {
                    success: false,
                    errorMessage: errorResponse.error || 'There was an error.',
                },
            });
        })
            .finally(function () {
            actions.setSubmitting(false);
        });
    };
    return (React.createElement(Modal, { onClose: onClose, title: Boolean(budget) ? 'Edit Budget' : 'Create Budget' },
        React.createElement(BudgetForm, { budget: budget, availableGroups: groupsList, handleFormSubmit: handleFormSubmit, submitResponse: formResponse, teamAccountBudgetsConfigurationOptions: teamAccountBudgetsConfigurationOptions, maxBudgetAmountLimit: maxBudgetAmountLimit, teamAccountId: teamAccountId })));
};
export default CreateBudgetModal;
